import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    activeTab: { type: String, default: "branding" }
  }

  connect() {
    const urlTab = new URL(window.location.href).searchParams.get("tab")
    const hashTab = window.location.hash.slice(1)
    const tab = urlTab || hashTab

    if (tab && this.tabTargets.some((entry) => entry.dataset.tab === tab)) {
      this.activeTabValue = tab
    }

    this.showTab(this.activeTabValue)
  }

  switch(event) {
    event.preventDefault()
    const tabId = event.currentTarget.dataset.tab
    this.activeTabValue = tabId
    this.showTab(tabId)

    const url = new URL(window.location.href)
    url.searchParams.set("tab", tabId)
    url.hash = tabId
    history.replaceState(null, "", url)
  }

  showTab(tabId) {
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tab === tabId
      tab.classList.toggle("bg-white", isActive)
      tab.classList.toggle("text-foreground", isActive)
      tab.classList.toggle("shadow-sm", isActive)
      tab.classList.toggle("font-medium", isActive)
      tab.classList.toggle("text-muted-foreground", !isActive)
      tab.classList.toggle("hover:text-foreground", !isActive)
      tab.classList.toggle("hover:bg-white/50", !isActive)
    })

    this.panelTargets.forEach((panel) => {
      const isActive = panel.dataset.panel === tabId
      panel.classList.toggle("hidden", !isActive)
    })
  }

  hashChanged() {
    const hash = window.location.hash.slice(1)
    if (hash && this.tabTargets.some((tab) => tab.dataset.tab === hash)) {
      this.activeTabValue = hash
      this.showTab(hash)
    }
  }
}
